import React, { useEffect, useState } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Anavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import tabStyles from '../assets/css/gapsy-tabs.module.css';
import { closeButtonStyle, Saveandadduser } from "../components/Propertyfile";
import { List_Checker, RoleandMapping, createTextFileApi, shariahconfig, mappingdata, OwnershipApi, userinfo, ListAllusers } from "../components/ApiProperty";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import formStyles from '../assets/css/gapsy-form.module.css';
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import { Modal, Button } from 'react-bootstrap';

const GapsyComplaintsConfig = () => {
    const [filteredUsers, setFilteredUsers] = useState([]);
    const navigate = useNavigate();
    const [showModalLdap, setShowModalLdap] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [checkerData, setCheckerData] = useState(null);
    const [showAllowUploadPopup, setShowAllowUploadPopup] = useState(false);
    const [pendingPayload, setPendingPayload] = useState(null); // store request for retry
    const [modalMessage3, setModalMessage3] = useState('');
    const [message, setMessage] = useState("");
    const [modalMessage, setModalMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success', 'warning', or 'error'
    const [disableInputs, setDisableInputs] = useState(false);
    const [passwordGenerated, setPasswordGenerated] = useState(false);
    const [selectedLocationValues, setSelectedLocationValues] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [departments, setDepartments] = useState([]); // Initialize as empty array
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [users, setUsers] = useState([]);
    const [formData, setFormData] = useState({
        searchUserId: "",
        userFirstName: ""
    });
    const [initialData, setInitialData] = useState({});
    const [selectedRole, setSelectedRole] = useState('');
    const [hierarchy, setHierarchy] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'userId', direction: 'asc' });
    const [error, setError] = useState("");
    const [selectedChecker, setSelectedChecker] = useState('');
    let csrfToken = sessionStorage.getItem("tokenizedSession");
    // const [permissions, setPermissions] = useState({
    //     viewMaker: false,
    //     viewChecker: false,
    //     viewRiskOfficer: false,
    //     downloadMaker: false,
    //     downloadChecker: false,
    //     downloadRiskOfficer: false,
    // });
    const initialPermissions = {
        downloadMaker: false,
        downloadChecker: false,
        downloadRiskOfficer: false,
    };

    const [permissions, setPermissions] = useState({
        ...initialPermissions,
    });

    const roleDetails = {
        maker: {
            userId: "10192",
            userName: "Pillar 2 Risk Maker"
        },
        checker: {
            userId: "10007",
            userName: "Pillar 2 Risk Checker"
        },
        riskOfficer: {
            userId: "10159",
            userName: "Risk Officer"
        }
    };

    const defaultPermissions = {
        // viewMaker: false,
        downloadMaker: false,
        // viewChecker: false,
        downloadChecker: false,
        // viewRiskOfficer: false,
        downloadRiskOfficer: false
    };

    const [selectedUser, setSelectedUser] = useState({
        userId: "",
        userName: ""
    });

    // const userIds = ["U001", "U002", "U003"];

    // const userNames = ["Vasanth", "Rahul", "Kiran"];

    // const departments = [
    //     "Finance",
    //     "Risk Management",
    //     "Compliance",
    //     "Audit"
    // ];

    const dept = sessionStorage.getItem("dept");

    // const roles = [
    //     "Shariah Risk"
    // ];


    const roles = ["Customer Complaints", "Media Publicity", "Operational Thresholds", "Leadership Thresholds", "Compliance"];

    const templateConfig = {
        "Shariah Risk": {
            apiTemplateName: "Risk_shariah_pillar1",
            fileSuffix: "shariah_config",
            displayRoles: {
                maker: {
                    userId: "10192",
                    userName: "Pillar 2 Risk Maker",
                    userRole: "maker",
                },
                checker: {
                    userId: "10007",
                    userName: "Pillar 2 Risk Checker",
                    userRole: "checker",
                },
                riskOfficer: {
                    userId: "10159",
                    userName: "Risk Officer",
                    userRole: "riskOfficer",
                },
            },
        },

        "Customer Complaints": {
            apiTemplateName: "Risk_customer_complaints",
            fileSuffix: "shariah_config",
            displayRoles: {
                maker: {
                    userId: "10192",
                    userName: "Pillar 2 Risk Maker",
                    userRole: "maker",
                },
                checker: {
                    userId: "10007",
                    userName: "Pillar 2 Risk Checker",
                    userRole: "checker",
                },
                riskOfficer: {
                    userId: "10159",
                    userName: "Risk Officer",
                    userRole: "riskOfficer",
                },
            },
        },
        "Media Publicity": {
            apiTemplateName: "Risk_media_publicity",
            fileSuffix: "shariah_config",
            displayRoles: {
                maker: {
                    userId: "10192",
                    userName: "Pillar 2 Risk Maker",
                    userRole: "maker",
                },
                checker: {
                    userId: "10007",
                    userName: "Pillar 2 Risk Checker",
                    userRole: "checker",
                },
                riskOfficer: {
                    userId: "10159",
                    userName: "Risk Officer",
                    userRole: "riskOfficer",
                },
            },
        },
         "Operational Thresholds": {
            apiTemplateName: "Risk_operational_thresholds",
            fileSuffix: "shariah_config",
            displayRoles: {
                maker: {
                    userId: "10192",
                    userName: "Pillar 2 Risk Maker",
                    userRole: "maker",
                },
                checker: {
                    userId: "10007",
                    userName: "Pillar 2 Risk Checker",
                    userRole: "checker",
                },
                riskOfficer: {
                    userId: "10159",
                    userName: "Risk Officer",
                    userRole: "riskOfficer",
                },
            },
        },
         "Leadership Thresholds": {
            apiTemplateName: "Risk_leadership_thresholds",
            fileSuffix: "shariah_config",
            displayRoles: {
                maker: {
                    userId: "10192",
                    userName: "Pillar 2 Risk Maker",
                    userRole: "maker",
                },
                checker: {
                    userId: "10007",
                    userName: "Pillar 2 Risk Checker",
                    userRole: "checker",
                },
                riskOfficer: {
                    userId: "10159",
                    userName: "Risk Officer",
                    userRole: "riskOfficer",
                },
            },
        },
         "Compliance": {
            apiTemplateName: "Risk_compliance",
            fileSuffix: "shariah_config",
            displayRoles: {
                maker: {
                    userId: "10192",
                    userName: "Pillar 2 Risk Maker",
                    userRole: "maker",
                },
                checker: {
                    userId: "10007",
                    userName: "Pillar 2 Risk Checker",
                    userRole: "checker",
                },
                riskOfficer: {
                    userId: "10159",
                    userName: "Risk Officer",
                    userRole: "riskOfficer",
                },
            },
        },
    };

    const fetchDepartments = async () => {
        try {
            setIsLoading(true);
            const config = {
                params: { "adminId": localStorage.getItem('userid'), ownership: "Y" },
                headers: {
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true
            }
            const response = await axios.post(OwnershipApi, {}, config);
            console.log("Ownership API Response:", response.data);

            // Extract Ownership array
            const ownershipList = response.data?.Ownership || [];
            console.log("Fetched Ownership List:", ownershipList);

            setDepartments(ownershipList);

        } catch (error) {
            console.error("Error fetching departments:", error);
            setDepartments([]);
        }
    };

    useEffect(() => {
        fetchDepartments();
    }, []);

    useEffect(() => {
        const fetchUsersData = async () => {
            try {
                setIsLoading(true);

                const config = {
                    params: { adminId: localStorage.getItem('userid') },
                    headers: { 'x-csrf-token': csrfToken },
                    withCredentials: true
                };

                // Parallel API calls
                const [allUsersRes, mappedUsersRes] = await Promise.all([
                    axios.post(ListAllusers, {}, config),
                    axios.post(RoleandMapping, {}, {
                        ...config,
                        params: {
                            ...config.params,
                            tableName: "user_role_mapping"
                        }
                    })
                ]);

                const allUsers = allUsersRes.data.users || [];

                const mappedUserIds = new Set(
                    (mappedUsersRes.data.data || []).map(item => String(item.USERID))
                );

                // FILTER: remove mapped users
                const filtered = allUsers.filter(
                    user => !mappedUserIds.has(String(user.userId))
                );

                setUsers(filtered);
                setFilteredUsers(filtered);

            } catch (error) {
                console.error("Error fetching users!", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchUsersData();
    }, []);

    const handleUserSelect = (e) => {
        const selectedId = e.target.value;

        const selectedUser = users.find(
            (user) => user.userId === selectedId
        );

        setFormData((prev) => ({
            ...prev,
            searchUserId: selectedId,
            userFirstName: selectedUser?.userFirstName || ""
        }));
    };

    const handleCancelUpload = () => {
        setShowAllowUploadPopup(false);
        setPendingPayload(null);
    };

    const handleForceUpload = async () => {
        try {
            setShowAllowUploadPopup(false);
            setIsLoading(true);

            const responseDb = await submitLdapData('Y'); // second call

            if (responseDb.data?.status === 'success') {
                setMessageType('success');
                setModalMessage(responseDb.data?.message);
            } else {
                setMessageType('error');
                setModalMessage(responseDb.data?.message || "Update failed");
            }

        } catch (error) {
            console.error(error);
            setMessageType('error');
            setModalMessage('Error while updating');
        } finally {
            setIsLoading(false);
            setPendingPayload(null);
        }
    };

    // const submitLdapData = async (allowUpdate = "") => {
    //     const adminId = localStorage.getItem("userid") || "";

    //     const jsonData = {
    //         template: "Shariah Risk",
    //         adminId,
    //         permissions: [
    //             {
    //                 userId: "10192",
    //                 userRole: "maker",
    //                 // view: permissions.viewMaker ? "Y" : "N",
    //                 download: permissions.downloadMaker ? "Y" : "N",
    //             },
    //             {
    //                 userId: "10007",
    //                 userRole: "checker",
    //                 // view: permissions.viewChecker ? "Y" : "N",
    //                 download: permissions.downloadChecker ? "Y" : "N",
    //             },
    //             {
    //                 userId: "10159", // Change to actual Risk Officer ID
    //                 userRole: "riskOfficer",
    //                 // view: permissions.viewRiskOfficer ? "Y" : "N",
    //                 download: permissions.downloadRiskOfficer ? "Y" : "N",
    //             },
    //         ],
    //     };

    //     const content = JSON.stringify(jsonData, null, 2);
    //     const filename = `${adminId}_shariah_config.json`;

    //     // Step 1: Save JSON file
    //     await axios.post(
    //         createTextFileApi,
    //         { filename, content },
    //         {
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 userId: adminId,
    //                 "x-csrf-token": csrfToken,
    //             },
    //             withCredentials: true,
    //         }
    //     );

    //     // Step 2: Call Mapping API
    //     const config = {
    //         headers: {
    //             adminId: adminId,
    //             "x-csrf-token": csrfToken,
    //         },
    //         withCredentials: true,
    //         params: {
    //             filePath: `/saswork/nas/${filename}`,
    //             Notifications: "IN",
    //             templateName: "Risk_shariah_pillar1",
    //             dept,
    //             allowUpdate,
    //         },
    //     };

    //     return await axios.post(shariahconfig, {}, config);
    // };


    const submitLdapData = async (allowUpdate = "") => {
        const adminId = localStorage.getItem("userid") || "";
        const configForTemplate = templateConfig[selectedRole];

        if (!configForTemplate) {
            throw new Error("Invalid template selected.");
        }

        const roleDetails = configForTemplate.displayRoles;

        const jsonData = {
            template: selectedRole,
            adminId,
            permissions: [
                {
                    userId: roleDetails.maker.userId,
                    userRole: roleDetails.maker.userRole,
                    download: permissions.downloadMaker ? "Y" : "N",
                },
                {
                    userId: roleDetails.checker.userId,
                    userRole: roleDetails.checker.userRole,
                    download: permissions.downloadChecker ? "Y" : "N",
                },
                {
                    userId: roleDetails.riskOfficer.userId,
                    userRole: roleDetails.riskOfficer.userRole,
                    download: permissions.downloadRiskOfficer ? "Y" : "N",
                },
            ],
        };

        const content = JSON.stringify(jsonData, null, 2);
        const filename = `${adminId}_${configForTemplate.fileSuffix}.json`;

        // Step 1: Save JSON file
        await axios.post(
            createTextFileApi,
            { filename, content },
            {
                headers: {
                    "Content-Type": "application/json",
                    userId: adminId,
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
            }
        );

        // Step 2: Call Mapping API with the selected template name
        const config = {
            headers: {
                adminId,
                "x-csrf-token": csrfToken,
            },
            withCredentials: true,
            params: {
                filePath: `/saswork/nas/${filename}`,
                Notifications: "IN",
                templateName: configForTemplate.apiTemplateName,
                dept,
                allowUpdate,
            },
        };

        return await axios.post(shariahconfig, {}, config);
    };


    const handleLdapSubmit = async (e) => {
        e.preventDefault();

        try {
            // Template validation
            if (!selectedRole) {
                setMessageType("error");
                setModalMessage("Please select a template.");
                return;
            }

            // At least one permission should be selected
            const hasPermission =
                permissions.downloadMaker ||
                permissions.downloadChecker ||
                permissions.downloadRiskOfficer;

            if (!hasPermission) {
                setMessageType("error");
                setModalMessage("Select at least one permission.");
                return;
            }

            setIsLoading(true);

            const responseDb = await submitLdapData();

            if (responseDb.data?.status?.toLowerCase() === "update") {
                setPendingPayload(true);

                setModalMessage3(`
                Configuration already exists.<br/>
                Do you want to update?
            `);

                setShowAllowUploadPopup(true);
                return;
            }

            if (responseDb.data?.status?.toLowerCase() === "success") {
                setMessageType("success");
                setModalMessage(responseDb.data.message);
            } else {
                setMessageType("error");
                setModalMessage(responseDb.data?.message || "Failed");
            }
        } catch (error) {
            console.error(error);
            setMessageType("error");
            setModalMessage("Error while processing request.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleClear = () => {
        setShowModalLdap(false);

        setFormData({
            searchUserId: "",
            userFirstName: "",
            userRole: "",
            orgHierarchy: ""
        });

        setSelectedUser({
            userId: "",
            userName: ""
        });
        setSelectedRole("");
        // setSelectedTemplate("");
        setSelectedDepartments([]);

        // Clear all checkboxes
        setPermissions(initialPermissions);

        setInitialData({});
        setEditIndex(null);
        setMessage("");
        setModalMessage("");
    };

    const handleCloseLdap = () => {

        if (messageType === "error") {
            setModalMessage("");
            return;
        }

        setShowModalLdap(false);

        setFormData({
            searchUserId: "",
            userFirstName: "",
            userRole: "",
            orgHierarchy: ""
        });

        setSelectedUser({
            userId: "",
            userName: ""
        });

        setSelectedRole("");
        // setSelectedTemplate("");
        setSelectedDepartments([]);

        // Clear all checkboxes
        setPermissions(initialPermissions);

        setModalMessage("");
        setInitialData({});
        setEditIndex(null);
        setMessage("");
    };
    const handleDashboard = (e) => {
        e.preventDefault();
        navigate('/gapsyAdashboard');
        // Additional logic if needed
    };

    const handleRaf = (e) => {
        e.preventDefault();
        navigate('/GapsyComplaintsConfiguration');
        // Additional logic if needed
    };

    const handleCloseModal = () => {
        setModalMessage('');
    };

    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a onClick={handleDashboard} className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                </li>
                                <li className={`breadcrumb-item ${styles.breadcrumbItem}`} style={{ cursor: "pointer" }} aria-current="page">
                                    <a onClick={handleRaf} className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-person-plus me-2" ></i>Configuration Mapping
                                    </a>
                                </li>
                                {/* <li className={`breadcrumb-item ${styles.breadcrumbItem}`} aria-current="page">
                                    <i onClick={handleRaf} className="bi bi-person-plus me-2"></i>RAF - User - Role Mapping
                                </li> */}
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-person-plus me-2"></i>Add New Configuration Mapping
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className='row'>
                                    <div className="col justify-content-center">
                                        <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                            <div className="card-body">
                                                <div className="mb-0">
                                                    <h6 className={`pb-1 mb-3 ${styles.borderBottom}`}>Add New Configuration Mapping</h6>
                                                    <div className="d-flex justify-content-center">
                                                        <div className="w-100" style={{ maxWidth: '700px' }}>
                                                            <div className={`mx-auto ${formStyles.formWrapper}`}>

                                                                <form className="form px-5" onSubmit={handleLdapSubmit}>

                                                                    <input type="hidden" name="adminId" value={localStorage.getItem('userid')} readOnly />

                                                                    <div className="form-group row mb-2">
                                                                        <label className="col-sm-4 col-form-label label-black">
                                                                            Select Template
                                                                        </label>

                                                                        <div className="col-sm-7">

                                                                            <select
                                                                                className="form-control form-control-sm"
                                                                                value={selectedRole}

                                                                                onChange={(e) => {
                                                                                    setSelectedRole(e.target.value);
                                                                                    setPermissions({ ...initialPermissions });
                                                                                }}

                                                                            >
                                                                                <option value="">Select Template</option>

                                                                                {roles.map((role, index) => (
                                                                                    <option key={index} value={role}>
                                                                                        {role}
                                                                                    </option>
                                                                                ))}

                                                                            </select>

                                                                        </div>
                                                                    </div>

                                                                    {/* {selectedRole && ( */}
                                                                    <>

                                                                        {/* VIEW */}
                                                                        {/* VIEW */}
                                                                        {selectedRole && (
                                                                            <div className="form-group row mb-3">

                                                                                <label className="col-sm-4 col-form-label label-black">
                                                                                    Permissions
                                                                                </label>

                                                                                <div className="col-sm-7">

                                                                                    <div className="table-on-homepage-only">

                                                                                        <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>

                                                                                            <thead className="thead-light">
                                                                                                <tr>
                                                                                                    <th>User ID</th>
                                                                                                    <th>User Role</th>
                                                                                                    <th>Download</th>
                                                                                                </tr>
                                                                                            </thead>


                                                                                            <tbody>
                                                                                                {selectedRole &&
                                                                                                    Object.entries(
                                                                                                        templateConfig[selectedRole].displayRoles
                                                                                                    ).map(([permissionKey, role]) => {
                                                                                                        const permissionField =
                                                                                                            permissionKey === "maker"
                                                                                                                ? "downloadMaker"
                                                                                                                : permissionKey === "checker"
                                                                                                                    ? "downloadChecker"
                                                                                                                    : "downloadRiskOfficer";

                                                                                                        return (
                                                                                                            <tr key={permissionKey}>
                                                                                                                <td>{role.userId}</td>

                                                                                                                <td className="text-start">
                                                                                                                    {role.userName}
                                                                                                                </td>

                                                                                                                <td>
                                                                                                                    <input
                                                                                                                        type="checkbox"
                                                                                                                        checked={permissions[permissionField]}
                                                                                                                        onChange={(e) =>
                                                                                                                            setPermissions((prev) => ({
                                                                                                                                ...prev,
                                                                                                                                [permissionField]:
                                                                                                                                    e.target.checked,
                                                                                                                            }))
                                                                                                                        }
                                                                                                                    />
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        );
                                                                                                    })}
                                                                                            </tbody>


                                                                                        </table>

                                                                                    </div>

                                                                                </div>

                                                                            </div>
                                                                        )}
                                                                    </>
                                                                    {/* )} */}

                                                                    {/* BUTTONS */}

                                                                    <div className="form-group row mt-2">

                                                                        <div className="col-sm-4"></div>

                                                                        <div className="col-sm-7 d-flex">

                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-secondary me-2"
                                                                                onClick={handleClear}
                                                                                style={closeButtonStyle}
                                                                            >
                                                                                Clear
                                                                            </button>

                                                                            <button
                                                                                type="submit"
                                                                                className="btn btn-sm btn-primary"
                                                                                style={Saveandadduser}
                                                                                disabled={disableInputs}
                                                                            >
                                                                                Submit
                                                                            </button>

                                                                        </div>

                                                                    </div>

                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {showAllowUploadPopup && (
                                            <Modal show onHide={handleCancelUpload} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                                <Modal.Header style={{ backgroundColor: '#366872', color: 'white', padding: '0.5rem 1rem' }}>
                                                    <Modal.Title style={{ fontSize: '16px' }}>Confirmation</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}
                                                    /* <sttong>{toTitleCase(editableTableName)}</sttong> Template is already exists. Do you wish to upload data with the same template? */
                                                    dangerouslySetInnerHTML={{
                                                        __html: modalMessage3.replace(/\n/g, '<br />')
                                                    }}>
                                                </Modal.Body>
                                                <Modal.Footer style={{ borderTop: 'none' }}>
                                                    <Button variant="secondary" onClick={handleCancelUpload}>No</Button>
                                                    <Button variant="primary" onClick={handleForceUpload}>Yes</Button>
                                                </Modal.Footer>
                                            </Modal>
                                        )}

                                        {/* Modal for messages */}
                                        <Modal
                                            show={!!modalMessage}
                                            onHide={handleCloseModal}
                                            backdrop="static"
                                            keyboard={false}
                                            style={{ marginTop: '12vh' }}
                                        >   
                                            <div
                                                className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                                                role="alert"
                                                style={{ marginBottom: '0' }}
                                            >
                                                <div className="d-flex align-items-center">
                                                    {messageType === 'success' ? (
                                                        <span className="me-2" style={{ color: 'green', fontSize: '14px' }}>✅</span>
                                                    ) : messageType === 'warning' ? (
                                                        <span className="me-2" style={{ color: '#ffc107', fontSize: '14px' }}>⚠️</span>
                                                    ) : (
                                                        <span className="me-2" style={{ color: 'red', fontSize: '14px' }}>❌</span>
                                                    )}
                                                    <p
                                                        style={{
                                                            display: 'inline',
                                                            marginBottom: '0px',
                                                            color: messageType === 'success'
                                                                ? 'green'
                                                                : messageType === 'warning'
                                                                    ? '#ffc107'
                                                                    : 'red'
                                                        }}
                                                    >
                                                        {modalMessage}
                                                    </p>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={handleCloseLdap}
                                                    style={{ width: '15px', height: '15px', fontSize: '8px', position: 'absolute', bottom: '10px', right: '10px' }}
                                                />
                                            </div>
                                        </Modal>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyComplaintsConfig;
